<template>
  <div class="stage-list">
    <ul class="stage-list__list">
      <template v-for="(step) in interactionSteps">
        <li v-if="resume.status.hasOwnProperty(step.key)"
            :key="step.key"
            class="stage-list__item" :class="getClass(step.key)">
          <BaseSvg :name="step.ico"/>
        </li>
      </template>

    </ul>
  </div>
</template>

<script>
  export default {
    name: 'APResumesBaseInteractionsPageRowStage',
    inject: [
        'interactionSteps'
    ],
    props: {
      resume: Object,
    },
    data() {
      return {}
    },
    computed: {

    },
    methods: {
      getClass(key) {
        const status = this.resume.status[key]
        return {
          '_done': status === 'checked',
          '_wait': status === 'pending',
          '_disabled': status === 'not_uploaded'
        }
      }
    }
  }
</script>

<style>

</style>
